import React, {useEffect, useState} from 'react';
import {DEFAULT_PAGE_SIZE, MAX_PAGE_LINK_DISPLAY, NotifyStatus, ORDER_BY} from '@app/constants/Common';
import * as UserService from '@app/services/UserService';
import {requestGetNotifications} from "@app/services/UserService";
import NotificationEditModal from "@pages/notification/NotificationEditModal";
import NotificationStatus from "@pages/notification/NotificationStatus";
import {eclipSizeText} from "@app/utils/CommonUtils";

const Notifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(0);
    const [showNotifyEditModal, setShowNotifyEditModal] = useState(false);
    const [selectNotify, setSelectNotify] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [orderBy, setOrderBy] = useState(ORDER_BY.DESC_UPDATE_DATE);
    const [status, setStatus] = useState("");
    const [displayPages, setDisplayPages] = useState([]);

    const setDisplayPageLink = (totalNumber) => {
        let numberPageCount = Math.floor(Number(totalNumber) / DEFAULT_PAGE_SIZE) + 1
        setNumberPages(numberPageCount);
    }

    const searchNotifications = (page, newOrderBy, pStatus) => {
        let statusValue = status
        if (pStatus) {
            statusValue = pStatus
        }
        setCurrentPage(page);
        setIsLoading(true)
        UserService.requestGetNotifications(
            {page: page, size: DEFAULT_PAGE_SIZE, order_by: newOrderBy, status: statusValue})
            .then((res) => {
            console.log(`Response-notifications:${JSON.stringify(res)}`);
            setNotifications(res.content.notifications);
            let totalNumber = res.content.totalCount ? Number(res.content.totalCount) : 0
            setTotalCount(totalNumber)
            setNumberPages(Math.floor(totalNumber / DEFAULT_PAGE_SIZE) + 1);
            if (currentPage === displayPages[0] || currentPage === displayPages[displayPages.length - 1]) {
                setDisplayPageLink(totalNumber)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
            setNotifications([]);
            setTotalCount(0)
            setNumberPages(0);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onChangeStatus = (event) => {
        console.log("onChangeStatus:" + event.target.value)
        setStatus(event.target.value)
        searchNotifications(currentPage, orderBy, event.target.value)
    }

    const nextPage = () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchNotifications(currPage, orderBy)
        } else {
            currPage = numberPages
        }
        // setCurrentPage(currPage)
    };

    const backPage = () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchNotifications(currPage, orderBy)
        } else {
            currPage = 0
        }
        // setCurrentPage(currPage)
    };

    const gotoPage = (targetPage) => {
        setCurrentPage(targetPage);
        searchNotifications(targetPage, orderBy)
    };

    const onChangeOrderBy = (event) => {
        setOrderBy(event.target.value)
        searchNotifications(currentPage, event.target.value)
    }

    useEffect(async () => {
        searchNotifications(currentPage, orderBy)
    }, []);

    const onShowEditModal = (notify) => {
        setSelectNotify(notify)
        setShowNotifyEditModal(true)
    }

    const onCloseEditModal = (isSuccess, reload) => {
        setSelectNotify({})
        setShowNotifyEditModal(false)
        if (reload) {
            searchNotifications(currentPage, orderBy)
        }
    }

    const onShowConfirmApprove = (event) => {

    }

    const onShowConfirmCancel = (event) => {

    }

    return (
        <div className='container-fluid'>
            <div className='card card-primary'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Quản lý thông báo</h3>
                </div>
                <div className='card-body'>
                    <div className='card card-default'>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Notifications ({totalCount})</h3>
                            <div className='card-tools row'>
                                <div className={"mr-5"}>
                                    <select className='form-control'
                                            name={'status'}
                                            value={status}
                                            onChange={event => onChangeStatus(event)}>
                                        <option value='0'>Tất cả trạng thái</option>
                                        <option value={NotifyStatus.WAITING}>Chờ duyệt</option>
                                        <option value={NotifyStatus.APPROVED}>Đã duyệt</option>
                                        <option value={NotifyStatus.REJECTED}>Từ chối</option>
                                    </select>
                                </div>
                                {numberPages > 1 &&
                                <ul className='pagination pagination-sm float-right mt-2'>
                                    <li className='page-item'>
                                        <button className='page-link' type={'button'}
                                                onClick={() => backPage()}>&laquo;</button>
                                    </li>
                                    <li className='page-item'>
                                        <button className='page-link' type={'button'}
                                                onClick={() => nextPage()}>&raquo;</button>
                                    </li>
                                </ul>
                                }
                            </div>
                            {isLoading &&
                            <div className={'col-sm-12 text-center'}>
                                <div className='spinner-grow text-primary' role='status'>
                                    <span className='sr-only'>Loading...</span>
                                </div>
                            </div>}
                        </div>
                        <div className='card-body table-responsive p-0'>
                            <table
                                className='table table-hover table-bordered text-center nowrap'
                                // style={{maxHeight: '80vh', overflow: 'scroll'}}
                            >
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Title</th>
                                    <th>Ứng viên</th>
                                    {/*<th>Phân loại</th>*/}
                                    <th>Người gửi</th>
                                    <th>Người gửi notes</th>
                                    <th>Feeback notes</th>
                                    <th>Trạng thái</th>
                                    <th>Ngày tạo</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {notifications && notifications.length > 0 && notifications.map((item, index) => (
                                    <tr key={`access_log_${index}`}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <a href="#" onClick={() => onShowEditModal(item)}
                                               className={'text-primary font-weight-bold'}>{item.title}</a>
                                        </td>
                                        <td>{item.candidate_id}</td>
                                        {/*<td>{item.type}</td>*/}
                                        <td>{item.send_user_name}</td>
                                        <td>{eclipSizeText(item.sender_note)}</td>
                                        <td>{eclipSizeText(item.feedback_note)}</td>
                                        <td><NotificationStatus value={item.status}/></td>
                                        <td>{item.created_date_time}</td>
                                        <td>
                                            <button type={"button"}
                                                    onClick={() => onShowEditModal(item)}
                                                    className={'btn btn-default'}>
                                                Xem chi tiết
                                            </button>
                                            {/*<div className="btn-group">*/}
                                            {/*    <button type="button" className="btn btn-default">Action</button>*/}
                                            {/*    <button type="button"*/}
                                            {/*            className="btn btn-default dropdown-toggle dropdown-icon"*/}
                                            {/*            data-toggle="dropdown">*/}
                                            {/*        <span className="sr-only">Toggle Dropdown</span>*/}
                                            {/*    </button>*/}
                                            {/*    <div className="dropdown-menu" role="menu">*/}
                                            {/*        <a href="#" onClick={() => onShowEditModal(item)}*/}
                                            {/*           rel="noopener noreferrer" className={'dropdown-item'}>Xem chi*/}
                                            {/*            tiết</a>*/}
                                            {/*        <a href="#" onClick={() => onShowConfirmApprove(item.id)}*/}
                                            {/*           className={'dropdown-item'}>Duyệt</a>*/}
                                            {/*        <a href="#" onClick={() => onShowConfirmCancel(item.id)}*/}
                                            {/*           className={'dropdown-item'}>Từ chối</a>*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='card-footer'>
                            <div className='card-tools'>
                                {numberPages > 1 &&
                                <ul className='pagination pagination-sm float-right'>
                                    <li className='page-item'>
                                        <button className='page-link' type={'button'}
                                                onClick={() => backPage()}>&laquo;</button>
                                    </li>
                                    <li className='page-item'>
                                        <button className='page-link' type={'button'}
                                                onClick={() => nextPage()}>&raquo;</button>
                                    </li>
                                </ul>
                                }
                            </div>
                        </div>
                        <NotificationEditModal isShow={showNotifyEditModal}
                                               notification={selectNotify}
                                               onClose={(isSuccess, reload) => onCloseEditModal(isSuccess, reload)}/>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Notifications;
